import React from "react";
import { ArrowDown } from "lucide-react";
import { HERO_IMAGE } from "../../data/kdm";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden bg-white"
    >
      {/* Background image — right side */}
      <div className="absolute inset-0 lg:left-[42%]">
        <img
          src={HERO_IMAGE}
          alt="KDM Group — global enterprise"
          className="w-full h-full object-cover"
        />
        {/* Soft overlay so text-side blends */}
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 lg:via-white/0 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-white/70 via-transparent to-transparent" />
      </div>

      <div className="relative max-w-[1400px] mx-auto w-full px-6 lg:px-12 pt-40 pb-20 lg:pb-28 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7 xl:col-span-6">
          <p className="overline" data-testid="hero-overline">
            Developer Profile · Est. 2010
          </p>

          <h1
            data-testid="hero-title"
            className="font-serif font-medium tracking-tight mt-7 text-[clamp(3rem,7vw,6.5rem)] leading-[0.98]"
          >
            A decade of
            <br />
            <span className="italic text-gold">global excellence</span>
            <br />
            & diversified resilience.
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-10 max-w-xl text-base lg:text-lg text-[--kdm-ink-soft] leading-relaxed"
          >
            The KDM Group is a multi-national conglomerate with 15+ years of operational
            history. Our footprint spans Sri Lanka, Italy, Spain, Bangladesh and the USA —
            built on financial stability, international standards and diversified asset
            management.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <a href="#verticals" data-testid="hero-cta-explore" className="btn-gold">
              Explore Our Verticals
              <ArrowDown size={14} />
            </a>
            <a href="#contact" data-testid="hero-cta-contact" className="btn-ghost">
              Partner With Us
            </a>
          </div>
        </div>

        {/* Floating stat plate */}
        <div className="lg:col-span-5 xl:col-span-6 flex lg:justify-end items-end">
          <div className="hidden lg:block w-full max-w-md">
            <div className="card-soft p-8 backdrop-blur-md bg-white/85">
              <p className="overline">Global Footprint</p>
              <p className="font-serif text-3xl mt-3 leading-tight">
                5 Countries · 6 Verticals · 600+ workforce
              </p>
              <div className="kdm-divider mt-5" />
              <p className="text-sm text-[--kdm-ink-soft] mt-5 leading-relaxed">
                Italian quality, Sri Lankan craftsmanship, American scale — engineered into
                every venture under one trusted name.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute left-6 lg:left-12 bottom-6 flex items-center gap-3 text-[--kdm-ink-soft]">
        <span className="block w-px h-10 bg-[--kdm-ink-soft] opacity-40" />
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
      </div>
    </section>
  );
}
